import Router from 'next/router';
import React from 'react';
import { UserApi } from '@api/business/api.utils';
import { getAuthFromContext } from '@auth/business/auth.utils';
import { LoginLayout } from '@auth/components/LoginLayout/LoginLayout.component';
import { ApiStatusCode } from '@utils/api.utils';
import { defaultNamespaces, urlRegex } from '@utils/strings';
import { castUrlParamToString, redirect, urlEnum } from '@utils/url';
import { PlcNextPage, PlcNextPageContext } from 'features/business/app.types';

export type LoginProps = {
  callbackUrl?: string;
  activationStatusCode?: number;
};

const LoginPage: PlcNextPage<LoginProps> = ({ callbackUrl, activationStatusCode }) => (
  <LoginLayout activationStatusCode={activationStatusCode} callbackUrl={callbackUrl} />
);

export async function activateAccount(token: string) {
  try {
    const { status } = await UserApi.activateAccount({ token });
    return status;
  } catch (e) {
    console.error('Error while activating account', e);
    return e?.response?.status || 500;
  }
}

LoginPage.getInitialProps = async (ctx: PlcNextPageContext) => {
  const activationToken = castUrlParamToString(ctx.query.activationToken);
  const { isAuthenticated } = getAuthFromContext(ctx);

  const pageDefaultState = {
    namespacesRequired: defaultNamespaces,
  };
  if (isAuthenticated && !activationToken) {
    redirect({
      Router,
      ctx,
      location: urlEnum.journal,
    });
    return pageDefaultState;
  }

  const activationStatusCode = activationToken ? await activateAccount(activationToken) : undefined;
  let callbackUrl = castUrlParamToString(ctx.query.callback);
  if (!callbackUrl) {
    callbackUrl = activationStatusCode === ApiStatusCode.accepted ? urlEnum.welcome : undefined;
  }
  const match = urlRegex.test(callbackUrl || '');
  return {
    ...pageDefaultState,
    activationStatusCode,
    callbackUrl: match ? callbackUrl : undefined,
  };
};

export default LoginPage;
